<div class="content-experience content-experience--catalogue">
    <div class="content-experience__body">
        <div class="box box-experience">
            <div class="box-experience__title mb-6">
                <h3>{{ "words.cerficates-title" | translate }}</h3>
            </div>
            <div class="flex flex-col gap-4 border rounded-lg p-4">
                <div class="flex  justify-end">
                    <msc-button class="msc-button--primary" icon="icon-plus" palette="secondary"
                        (click)="openModalAdd()">
                        {{ "words.add" | translate }}
                    </msc-button>
                </div>
                <div class="flex flex-col gap-4">
                    <div class="flex flex-row box-experience__title-tr p-3 gap-3">
                        <div class="w-2/5">
                            <span class="font-bold text-gray-700 text-sm  whitespace-normal">{{ "words.description" |
                                translate }}</span>
                        </div>
                        <div class="w-1/3" *ngIf="!isPok">
                            <span class="font-bold text-gray-700 text-sm  whitespace-normal">{{ "words.groups" |
                                translate }}</span>
                        </div>
                        <div class="w-1/3">
                            <span class="font-bold text-gray-700 text-sm  whitespace-normal">{{ "words.template" |
                                translate }}</span>
                        </div>
                        <div class="w-1/6">
                            <span class="font-bold text-gray-700 text-sm  whitespace-normal">{{ "words.status" |
                                translate }}</span>
                        </div>
                        <div class="w-1/6">
                            <span class="font-bold text-gray-700 text-sm  whitespace-normal">{{ "words.create-at" |
                                translate }}</span>
                        </div>
                        <div class="w-1/12">
                            <span></span>
                        </div>
                        <div class="w-1/12">
                            <span></span>
                        </div>
                    </div>
                    <ng-container *ngIf="isLoadingTable">
                        <msc-common-spinner></msc-common-spinner>
                    </ng-container>
                    <div class="flex flex-col" *ngIf="!isLoadingTable">
                        <div class=" gap-3  flex flex-row w-full p-3 box-experience__title"
                            *ngFor="let row of emitedTemplates?.templates">
                            <div class="w-2/5">
                                <span class=" text-gray-500  whitespace-normal">{{ row.description }}</span>
                            </div>
                            <!-- Xertify: show group -->
                            <div class="w-1/3" *ngIf="!isPok">
                                <span class=" text-gray-500  whitespace-normal">{{ row.xGroupName }}</span>
                            </div>
                            <!-- Show template name based on provider -->
                            <div class="w-1/3">
                                <span class=" text-gray-500  whitespace-normal" *ngIf="isPok">{{ row.pTemplateName }}</span>
                                <span class=" text-gray-500  whitespace-normal" *ngIf="!isPok">{{ row.xTemplateName }}</span>
                            </div>
                            <div class="w-1/6 flex align-center">
                                <div class="mr-3">
                                    <span class=" text-gray-500  whitespace-normal"
                                        *ngIf="row.status == 1 || row.status == '1'"></span>
                                    <span class=" text-gray-500  whitespace-normal"
                                        *ngIf="row.status == 0 || row.status == '0'"></span>
                                </div>
                                <msc-common2-switch type="tick" [value]="row.status == 1 || row.status == '1'"
                                    (changeEvent)="toggleTemplateStatus(row.id)"></msc-common2-switch>
                            </div>
                            <div class="w-1/6">
                                <span class=" text-gray-500  whitespace-normal" *ngIf="isPok">{{ formatData(row.startCertificateAt) }}</span>
                                <span class=" text-gray-500  whitespace-normal" *ngIf="!isPok">{{ formatData(row.createdAt) }}</span>
                            </div>
                            <div class="flex gap-3 flex-row">
                                <div>
                                    <msc-button icon="icon-edit" palette="primary" [tooltip]="'words.edit' | translate"
                                        (click)="openEdit(row)">
                                    </msc-button>
                                </div>
                                <div>
                                    <msc-button *ngIf="isPok ? row.deletedAt == null : row.deletedAt == null"
                                        icon="icon-trash-2" palette="primary" [tooltip]="'common.delete' | translate"
                                        (click)="openModalDelete(row.id)">
                                    </msc-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<msc-common-modal size="40vw" #modalAdd [title]="(isEdit ? 'words.template-edit' : 'words.template-create') | translate">
    <ng-template>
        <ng-container *ngIf="isLoading">
            <msc-common-spinner></msc-common-spinner>
        </ng-container>
        <ng-container *ngIf="!isLoading && !hasError">
            <!--
            <div class="date-till flex align-center justify-start">
                <p>{{ "words.from-the" | translate }}</p>

                <div
                    class="select"
                    [ngClass]="{ active: showDate }"
                    (click)="displayed('date_from')"
                >
                    <div class="select__content">
                        <p class="select__placeholder">
                            date here
                            <i class="icon icon-arrow-ios-down"></i>
                        </p>

                        <div
                            class="select__dropdown"
                            (click)="$event.stopPropagation()"
                        >
                            <msc-datepicker
                                #dateFrom
                                [date]="dates.from"
                                [limit]="{ max: today }"
                                [actions]="true"
                                (onUpdate)="updateDateFrom($event)"
                                (onClose)="displayed('date_from', true)"
                            ></msc-datepicker>
                        </div>
                    </div>
                </div>
            </div>
-->
            <div class="flex justify-between mb-3">
                <msc-input [label]="'words.description' | translate" [placeholder]="'words.description' | translate"
                    [(ngModel)]="templateItemDescription" (ngModelChange)="onInputChange()"
                    class="w-full pr-3"></msc-input>

                <div class="w-full pl-3">
                    <p class="text-gray-500 text-base">{{ "words.template" | translate }}</p>
                    <!-- POK Templates -->
                    <msc-common-select *ngIf="isPok" class="text-sm max-w-full"
                        [data]="emitedTemplates?.pTemplates || emitedTemplates?.p_templates">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="select-main select-button-form">
                                <ng-container *ngIf="selectSelections.template.name; else pokPlaceholder">
                                    <span>{{ selectSelections.template.name }}</span>
                                </ng-container>
                                <ng-template #pokPlaceholder>
                                    <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                                </ng-template>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <button class="select-option select-button-form" (click)="onSelectType(datum, 'template')">
                                <span>{{ datum.name }}</span>
                            </button>
                        </ng-template>
                    </msc-common-select>
                    <!-- Xertify Templates -->
                    <msc-common-select *ngIf="!isPok" class="text-sm max-w-full" [data]="emitedTemplates.xTemplates">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="select-main select-button-form">
                                <ng-container *ngIf="selectSelections.template.name; else xertifyPlaceholder">
                                    <span>{{ selectSelections.template.name }}</span>
                                </ng-container>
                                <ng-template #xertifyPlaceholder>
                                    <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                                </ng-template>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <button class="select-option select-button-form" (click)="onSelectType(datum, 'template')">
                                <span>{{ datum.name }}</span>
                            </button>
                        </ng-template>
                    </msc-common-select>
                </div>
            </div>

            <!-- grupos/catalogos -->
            <div class="flex justify-between mb-3">
                <!-- Xertify: Groups selector (only for Xertify) -->
                <div class="w-full pr-3" *ngIf="!isPok">
                    <p class="text-gray-500 text-base">{{ "words.groups" | translate }}</p>
                    <msc-common-select class="text-sm max-w-full" [data]="emitedTemplates.xGroups">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="select-main select-button-form">
                                <ng-container *ngIf="selectSelections.group.name; else groupPlaceholder">
                                    <span>{{ selectSelections.group.name }}</span>
                                </ng-container>
                                <ng-template #groupPlaceholder>
                                    <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                                </ng-template>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <button class="select-option" (click)="onSelectType(datum, 'group')">
                                <span>{{ datum.name }}</span>
                            </button>
                        </ng-template>
                    </msc-common-select>
                </div>
                <div [ngClass]="{'w-full': isPok, 'w-full pl-3': !isPok}">
                    <p class="text-gray-500 text-base">{{ "words.catalogs" | translate }}</p>
                    <msc-common-select type="multi" [data]="emitedTemplates.catalogs" [disabled]="loading"
                        style="overflow: hidden">
                        <ng-template #buttonTemplate let-data="data">
                            <ng-container *ngIf="selectedItem.length; else emptyTemplate">
                                <div class="selections-content text-ellipsis overflow-hidden whitespace-nowrap">
                                    <ng-container *ngFor="
                                            let datum of selectedItem;
                                            let i = index
                                        ">
                                        <span class="selections">
                                            {{ datum.name }}
                                        </span>
                                        &nbsp;
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #emptyTemplate>
                                <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                            </ng-template>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <div class="option">
                                <msc-common2-checkbox type="tick" [value]="datum.isSelected" [label]="datum.name"
                                    (changeEvent)="onSet($event, datum)"></msc-common2-checkbox>
                            </div>
                        </ng-template>
                    </msc-common-select>
                </div>
            </div>
            <!--fecha/puntacion-->
            <div class="flex justify-between mb-3">
                <div class="flex flex-col w-full">
                    <p class="text-gray-500 text-base" style="margin-bottom: -1.5rem;">{{ 'words.start-certificate-date'
                        | translate }}</p>
                    <msc-input [(ngModel)]="initialCertificateDate" (ngModelChange)="onInputChange()" type="date"
                        class="w-full pr-3"></msc-input>
                </div>
                <msc-input [label]="'words.minimum-score' | translate" [placeholder]="'words.minimum-score' | translate"
                    [(ngModel)]="templateItemMinimumProgress" (ngModelChange)="onInputChange()" type="number"
                    onkeydown="return event.keyCode !== 69" (change)="validateScale($event)"
                    class="w-full pl-3"></msc-input>
            </div>

            <!--campos-->
            <div class="flex justify-between mb-3">
                <!--
                    Campo POK. Cuando se pudo consultar la plantilla, se elige de una lista con los
                    campos que ESA plantilla declara: escribirlo a mano hacia que un typo no diera
                    error al guardar sino que rompiera la emision entera despues.
                    Si POK no respondio (pokFieldsAvailable=false) se cae al input libre a
                    proposito, para no bloquear la configuracion por una caida del proveedor.
                -->
                <div *ngIf="isPok && pokFieldsAvailable" class="w-full pr-3">
                    <p class="text-gray-500 text-base">{{ "words.pok-field" | translate }}</p>
                    <msc-common-select class="text-sm max-w-full" [data]="pokTemplateFields">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="select-main select-button-form">
                                <ng-container *ngIf="newItemName; else pokFieldPlaceholder">
                                    <span>{{ newItemName }}</span>
                                </ng-container>
                                <ng-template #pokFieldPlaceholder>
                                    <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                                </ng-template>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <button class="select-option" (click)="onSelectPokField(datum)">
                                <span>{{ datum.name }}</span>
                            </button>
                        </ng-template>
                    </msc-common-select>
                </div>

                <msc-input *ngIf="!isPok || !pokFieldsAvailable"
                    [label]="isPok ? ('words.pok-field' | translate) : ('words.xertify' | translate)"
                    [placeholder]="isPok ? ('words.pok-field' | translate) : ('words.xertify' | translate)"
                    [(ngModel)]="newItemName" class="w-full pr-3"></msc-input>

                <div class="w-full pl-3">

                    <p class="text-gray-500 text-base">{{ "words.set-local-field" | translate }}</p>
                    <msc-common-select class="text-sm max-w-full" [data]="emitedTemplates?.localFields">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="select-main select-button-form">
                                <ng-container *ngIf="selectedItemId; else localFieldPlaceholder">
                                    <span>{{ selectedItemId }}</span>
                                </ng-container>
                                <ng-template #localFieldPlaceholder>
                                    <span style="color: #9ca3af;">{{ "common.select" | translate }}</span>
                                </ng-template>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <button class="select-option" (click)="onSelectType(datum, 'localField')">
                                <span>{{ datum.name | translate }}</span>
                            </button>
                        </ng-template>
                    </msc-common-select>

                </div>

            </div>

            <div class="flex w-full mb-3">
                <msc-input [label]="'words.field-value' | translate" [placeholder]="'words.field-value' | translate"
                    [(ngModel)]="newItemLabel" [disabled]="newItemId != 'custom'" class="w-full pr-3"></msc-input>
                <msc-button class="ml-3 mb-2" type="fab" icon="icon-plus"
                    (click)="isPok ? addNewItemToNewListPok() : addNewItemToNewList()"
                    [disabled]="verifyNewInputs()"></msc-button>
            </div>




            <div class="flex mb-1 place-content-between w-full items-end" *ngFor="let item of newList; let i = index">
                <div class="flex w-full">
                    <div class="flex w-3/6 flex-col">
                        <p>{{ newListDisplayed[i]?.xertifyField }}</p>
                    </div>
                    <div class="flex w-3/6 flex-col ml-3">
                        <p>{{ newListDisplayed[i]?.localField }}</p>
                    </div>
                    <div class="flex w-3/6 flex-col ml-3">
                        <p *ngIf="!newListDisplayed[i]?.valueField; else editValue">{{ item.local_value }}</p>
                        <ng-template #editValue>
                            <p>{{ newListDisplayed[i]?.valueField }}</p>
                        </ng-template>
                    </div>
                </div>
                <msc-button [tooltip]="'words.delete' | translate" type="fab" icon="icon-trash"
                    (click)="removeItemFromNewList(i)"></msc-button>
            </div>
            <div class="flex items-center mt-5 space-x-5 justify-end">
                <msc-button palette="primary" (click)="modalAdd.onClose()">
                    {{ "common.cancel" | translate }}
                </msc-button>

                <msc-button *ngIf="!isEdit" class="msc-button--primary" palette="primary" [disabled]="!checkInputs"
                    (click)="createTemplate()">
                    {{ "common.save" | translate }}
                </msc-button>

                <msc-button *ngIf="isEdit" class="msc-button--primary" palette="primary" (click)="updateTemplate()">
                    {{ "common.edit" | translate }}
                </msc-button>
            </div>
        </ng-container>
        <ng-container *ngIf="!isLoading && hasError">
            <h2>{{ errorMsg | translate }}</h2>
        </ng-container>
    </ng-template>
</msc-common-modal>

<msc-common-modal size="20vw" #modalDelete [title]="'words.template-delete-title' | translate">
    <ng-template>
        <span>{{'words.template-delete-text' | translate}}</span>
        <div class="flex items-center mt-3 space-x-5 justify-start">
            <msc-button class="msc-button--primary mr-3" palette="primary" (click)="deleteTemplate()">
                {{ "common.delete" | translate }}
            </msc-button>

            <msc-button palette="primary" (click)="modalAdd.onClose()">
                {{ "common.cancel" | translate }}
            </msc-button>
        </div>
    </ng-template>
</msc-common-modal>